import { css } from 'lit-element';
const style = css`
:host([align="column"]) fc-segmented-control {
  --fc-segmented-control-width: 100%;
}`;
export default style;
